/** Nivåerna har samma värden som fördelningsraderna i databasen. */
export type FeeDistributionLevel = 'förbund' | 'distrikt' | 'förening';

export type FeeDistributionRecipient = {
  level: FeeDistributionLevel;
  recipientId: number;
  name?: string;
  orgNr?: string;
  bankGiro?: string;
  postGiro?: string;
  paymentCount: number;
  amount: number;
};

export type FeeDistributionResponse = {
  ownerId: number;
  dateFrom: string;
  dateTo: string;
  paymentCount: number;
  totalPaid: number;
  countryAmount: number;
  districtAmount: number;
  localAmount: number;
  paymentsWithoutDistribution: number;
  amountWithoutDistribution: number;
  recipients: FeeDistributionRecipient[];
};

export type FeeDistributionRecordRow = {
  id: number;
  level: FeeDistributionLevel;
  recipientId: number;
  name?: string;
  orgNr?: string;
  bankGiro?: string;
  postGiro?: string;
  iban?: string;
  paymentCount: number;
  amount: number;
  status: number;
  statusInfo?: string;
  paidDate?: string;
};

export type FeeDistributionRecord = {
  id: number;
  ownerId: number;
  number: number;
  name?: string;
  created: string;
  dateFrom: string;
  dateTo: string;
  paymentCount: number;
  totalAmount: number;
  fileName?: string;
  paymentFileId?: number;
  rows: FeeDistributionRecordRow[];
};

/** Samma värden som PaymentDistributionRowStatus i API:et. */
export enum FeeDistributionRowStatusEnum {
  ReadyToPay = 10,
  NoAccount = 20,
  Paid = 30,
  NotPaidOut = 40,
}

export type FeeDistributionSearchFilter = {
  ownerId: number;
  dateFrom: string;
  dateTo: string;
};

export type FeeDistributionPaymentFileResponse = {
  recordId: number;
  exportFileId: number;
  fileName: string;
  paymentCount: number;
  totalAmount: number;
  payDate: string;
};

/** Avsändaren i betalningsfilen, alltså vem pengarna dras från. */
export type FeeDistributionDebitSettings = {
  orgName?: string;
  orgNumber?: string;
  account?: string;
};
